import AdminProductMaterialsFields from './AdminProductMaterialsFields';

export default AdminProductMaterialsFields;
